export const DocumentType = {
  FACILITY: 'FACILITY',
  STEP: 'STEP',
  USER: 'USER',
  GLOBAL: 'GLOBAL'
};